import { render } from "./Procedure.vue?vue&type=template&id=23d57903"
import script from "./Procedure.vue?vue&type=script&lang=js"
export * from "./Procedure.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTL-Project\\Mbf5_ZMP_CongAn\\ATTP_PC03\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__